import React, { useEffect, useState } from 'react'

import { Button, Input } from 'antd'

import { getApiTargetInfo } from 'core'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getPermitActions,
  getEnvConfig,
} from 'core/selectors'

import { Label } from 'core/screen-util'
import { SppAcaUnitTypesHeaders } from './ACAHeaders'
import { deleteUnitTypeInfo, getUnitTypeInfo, postUnitTypeInfo } from './acaapi'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'

const ACAUniType = ({ permitActions }) => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '100px 300px 150px 100px 150px',
          gap: 5,
        }}
      >
        <Label>Unit Type :</Label>
        <Input
          value={insertData.sppUnittype}
          onChange={e =>
            setInsertData({ ...insertData, sppUnittype: e.target.value })
          }
          max={200}
        />

        <div style={{ gridColumnEnd: 'span 3' }}>
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>

          <Button
            type="primary"
            onClick={() => onAdd(false)}
            style={{ marginLeft: '20px' }}
          >
            Add & Hide
          </Button>
          <Button
            type="danger"
            onClick={onCancel}
            style={{ marginLeft: '20px' }}
          >
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  const [withoutModify, setWithoutModify] = useState(true)
  useEffect(() => {
    const isAdmin = hasAccesPermits({
      actionPermits: permitActions,
      eventActions: [ScreenPermissions.AEP_ACA_SPP_DATA_WRITE],
      matchAny: true,
    })
    setWithoutModify(!isAdmin)
  }, [permitActions])

  return (
    <CommonScreen
      title="SPP Unit Classifications"
      header={SppAcaUnitTypesHeaders}
      initialSortOptions={SppAcaUnitTypesHeaders}
      saveTask={postUnitTypeInfo}
      retrieveTask={getUnitTypeInfo}
      deleteTask={deleteUnitTypeInfo}
      altBy={d => d.sppUnittype}
      autoRetrieve
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      isAdminScreen={false}
      withoutModify={withoutModify}
      allowInsert={!withoutModify}
      // widthOffset={550}
      // heightOffset={100}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  permitActions: getPermitActions(state),
  envConfig: getEnvConfig(state),
})

export default connect(mapStateToProps)(ACAUniType)
